import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import { Megaphone } from "lucide-react";
import { useDebateStore } from "../../store/debateStore";
import { selectInterrupt } from "../../store/selectors";
import { t } from "../../i18n";

export function InterruptOverlay() {
  const reduceMotion = useReducedMotion();
  const { active, pivot } = useDebateStore(selectInterrupt);

  return (
    <AnimatePresence>
      {active ? (
        <motion.div
          key="overlay"
          role="status"
          aria-live="assertive"
          className="absolute inset-0 z-30 grid place-items-center"
          initial={reduceMotion ? false : { opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: reduceMotion ? 0 : 0.3 }}
        >
          {/* Radial blur background */}
          <div
            className="absolute inset-0"
            style={{
              background: "radial-gradient(ellipse at 50% 50%, hsl(var(--bg-page) / 0.92), hsl(var(--bg-page) / 0.7) 80%)",
              backdropFilter: "blur(8px)",
            }}
            aria-hidden
          />

          {/* Pulse rings */}
          <div className="absolute inset-0 grid place-items-center pointer-events-none" aria-hidden>
            <motion.span
              className="absolute h-48 w-48 rounded-full border border-amber-400/20"
              animate={{ scale: [1, 1.6], opacity: [0.4, 0] }}
              transition={{ duration: 2, repeat: Infinity, ease: "easeOut" }}
            />
            <motion.span
              className="absolute h-32 w-32 rounded-full border border-amber-400/30"
              animate={{ scale: [1, 1.5], opacity: [0.5, 0] }}
              transition={{ duration: 2, repeat: Infinity, ease: "easeOut", delay: 0.5 }}
            />
          </div>

          {/* Central content */}
          <motion.div
            className="relative max-w-md rounded-2xl border border-white/[0.08] bg-[hsl(220_22%_8%/0.95)] p-8 text-center backdrop-blur-xl shadow-[0_16px_64px_-12px_rgb(0_0_0/0.6)]"
            initial={reduceMotion ? false : { y: 24, opacity: 0, scale: 0.95 }}
            animate={{ y: 0, opacity: 1, scale: 1 }}
            exit={{ y: 12, opacity: 0, scale: 0.97 }}
            transition={
              reduceMotion ? { duration: 0 } : { type: "spring", stiffness: 180, damping: 22 }
            }
          >
            {/* Icon with glow */}
            <div className="mx-auto mb-4 grid h-14 w-14 place-items-center rounded-full bg-amber-500/15 text-amber-300 ring-2 ring-amber-500/30 shadow-[0_0_24px_-4px_hsl(38_90%_55%/0.4)]">
              <Megaphone className="h-6 w-6" aria-hidden />
            </div>

            <div className="text-[10px] uppercase tracking-[0.25em] font-bold text-amber-300/80 mb-3">
              {t("moderator.pivotOverlayTitle")}
            </div>

            <p className="text-base leading-relaxed text-fg-strong text-balance">
              {pivot ?? "Tartışmaya yön veriliyor…"}
            </p>
          </motion.div>
        </motion.div>
      ) : null}
    </AnimatePresence>
  );
}
